export class OneColumnSearchData {
    propertyName?: string | undefined;
    propertyValue?: string | undefined;
}
